import { cva } from 'class-variance-authority'
import { Circle, CircleCheck } from 'lucide-react'
import PropTypes from 'prop-types'

import { cn } from '@/utils/helpers'

export const STATUS = {
  COMPLETED: 'Completed',
  IN_PROGRESS: 'In Progress',
  NOT_STARTED: 'Not Started',
}

/**
 * StatusIcon
 * @param {Object} props
 * @param {('Completed'|'In Progress'|'Not Started')} props.status
 * @param {('small'|'medium'|'large')} [props.size='medium']
 * @param {('complete'|'incomplete'|'status')} [props.icon='status'] Icon to display, defaults to the icon representing the passed in status.
 */
function StatusIcon({ status, size = 'medium', icon = 'status' }) {
  let Icon = Circle
  if (icon === 'status') {
    Icon = status === STATUS.COMPLETED ? CircleCheck : Circle
  } else if (icon === 'complete') {
    Icon = CircleCheck
  }
  const iconStyles = cva('', {
    variants: {
      status: {
        Completed: 'text-success',
        'In Progress': 'text-yellow-500',
        'Not Started': 'text-gray-500',
      },
      size: {
        small: 'size-4',
        medium: 'size-6',
        large: 'size-8',
      },
    },
    defaultVariants: {
      status: 'Not Started',
      size: 'medium',
    },
  })

  return <Icon className={cn(iconStyles({ status, size }))} />
}

StatusIcon.propTypes = {
  status: PropTypes.oneOf(['Completed', 'In Progress', 'Not Started']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  icon: PropTypes.oneOf(['complete', 'incomplete', 'status']),
}

export default StatusIcon
